/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ICommand } from '../ICommand';
import { SimplifiedParameterType } from '../models/SimplifiedParameterType';
import { SimplifiedPropertyType } from '../models/SimplifiedPropertyType';
import { SimplifiedType } from '../models/SimplifiedType';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { DocumentType } from '../../core/models/DocumentType';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { Extension } from '../../core/models/Extension';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IExampleParent } from '../../core/models/common/IExampleParent';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { IServerParent } from '../../core/models/common/IServerParent';
import { Info } from '../../core/models/common/Info';
import { Parameter } from '../../core/models/common/Parameter';
import { Schema } from '../../core/models/common/Schema';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Server } from '../../core/models/common/Server';
import { IOasParameterParent } from '../../openapi/models/IOasParameterParent';
import { IOasPropertySchema } from '../../openapi/models/IOasPropertySchema';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasParameter } from '../../openapi/models/OasParameter';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { OasResponse } from '../../openapi/models/OasResponse';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas20Response } from '../../openapi/v2/models/Oas20Response';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { Oas20SchemaDefinition } from '../../openapi/v2/models/Oas20SchemaDefinition';
import { IOas30MediaTypeParent } from '../../openapi/v3/models/IOas30MediaTypeParent';
import { Oas30Example } from '../../openapi/v3/models/Oas30Example';
import { Oas30MediaType } from '../../openapi/v3/models/Oas30MediaType';
import { Oas30Operation } from '../../openapi/v3/models/Oas30Operation';
import { Oas30Parameter } from '../../openapi/v3/models/Oas30Parameter';
import { Oas30ResponseDefinition } from '../../openapi/v3/models/Oas30ResponseDefinition';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';

/**
 * This factory is used to create an instance of {@link ICommand} given a "type" that was previously
 * serialized as part of the marshalling of a command to a JS object (and ultimately a JSON string).
 * The type of command is typically its short classname, but not always.
 * @author eric.wittmann@gmail.com
 * @class
 */
export class CommandFactory {
    /**
     * Called to create a command of a given type.
     * @param {string} cmdType
     * @return {*}
     */
    public static create(cmdType : string) : ICommand {
        switch((cmdType)) {
        case "AggregateCommand":
            {
                return new AggregateCommand();
            };
        case "AddSchemaDefinitionCommand_20":
            {
                return new AddSchemaDefinitionCommand_20();
            };
        case "AddSchemaDefinitionCommand_30":
            {
                return new AddSchemaDefinitionCommand_30();
            };
        case "AddExampleCommand_30":
            {
                return new AddExampleCommand_30();
            };
        case "AddParameterExampleCommand_30":
            {
                return new AddParameterExampleCommand_30();
            };
        case "AddPathItemCommand":
        case "AddPathItemCommand_20":
        case "AddPathItemCommand_30":
            {
                return new AddPathItemCommand();
            };
        case "AddSecurityRequirementCommand":
            {
                return new AddSecurityRequirementCommand();
            };
        case "AddResponseDefinitionCommand_20":
            {
                return new AddResponseDefinitionCommand_20();
            };
        case "AddResponseDefinitionCommand_30":
            {
                return new AddResponseDefinitionCommand_30();
            };
        case "AddChildSchemaCommand":
            {
                return new AddChildSchemaCommand();
            };
        case "ChangePropertyCommand_20":
        case "ChangePropertyCommand_30":
        case "ChangePropertyCommand":
            {
                return <any>(new ChangePropertyCommand());
            };
        case "ChangeDescriptionCommand_20":
        case "ChangeDescriptionCommand_30":
        case "ChangeDescriptionCommand":
            {
                return new ChangeDescriptionCommand();
            };
        case "ChangeTitleCommand_20":
        case "ChangeTitleCommand_30":
        case "ChangeTitleCommand":
            {
                return new ChangeTitleCommand();
            };
        case "ChangeVersionCommand_20":
        case "ChangeVersionCommand_30":
        case "ChangeVersionCommand":
            {
                return new ChangeVersionCommand();
            };
        case "ChangeContactCommand_20":
        case "ChangeContactCommand_30":
        case "ChangeContactCommand":
            {
                return new ChangeContactCommand();
            };
        case "ChangeLicenseCommand_20":
        case "ChangeLicenseCommand_30":
        case "ChangeLicenseCommand":
            {
                return new ChangeLicenseCommand();
            };
        case "ChangeMediaTypeTypeCommand":
            {
                return new ChangeMediaTypeTypeCommand();
            };
        case "ChangeParameterTypeCommand_20":
            {
                return new ChangeParameterTypeCommand_20();
            };
        case "ChangeParameterDefinitionTypeCommand_20":
            {
                return new ChangeParameterDefinitionTypeCommand_20();
            };
        case "ChangeParameterTypeCommand_30":
            {
                return new ChangeParameterTypeCommand_30();
            };
        case "ChangeParameterDefinitionTypeCommand_30":
            {
                return new ChangeParameterDefinitionTypeCommand_30();
            };
        case "ChangePropertyTypeCommand":
        case "ChangePropertyTypeCommand_20":
        case "ChangePropertyTypeCommand_30":
            {
                return new ChangePropertyTypeCommand();
            };
        case "ChangeResponseTypeCommand":
        case "ChangeResponseTypeCommand_20":
        case "ChangeResponseDefinitionTypeCommand_20":
            {
                return new ChangeResponseTypeCommand();
            };
        case "ChangeSecuritySchemeCommand_20":
            {
                return new ChangeSecuritySchemeCommand_20();
            };
        case "ChangeSecuritySchemeCommand_30":
            {
                return new ChangeSecuritySchemeCommand_30();
            };
        case "ChangeServerCommand":
            {
                return new ChangeServerCommand();
            };
        case "ChangeSchemaTypeCommand":
            {
                return new ChangeSchemaTypeCommand();
            };
        case "ChangeSchemaInheritanceCommand":
            {
                return new ChangeSchemaInheritanceCommand();
            };
        case "DeleteContactCommand_20":
        case "DeleteContactCommand_30":
        case "DeleteContactCommand":
            {
                return new DeleteContactCommand();
            };
        case "DeleteAllExamplesCommand_30":
        case "DeleteAllExamplesCommand":
            {
                return new DeleteAllExamplesCommand();
            };
        case "DeleteAllParameterExamplesCommand_30":
        case "DeleteAllParameterExamplesCommand":
            {
                return new DeleteAllParameterExamplesCommand();
            };
        case "DeleteAllOperationsCommand":
            {
                return new DeleteAllOperationsCommand();
            };
        case "DeleteAllParametersCommand_20":
        case "DeleteAllParametersCommand_30":
        case "DeleteAllParametersCommand":
            {
                return new DeleteAllParametersCommand();
            };
        case "DeleteAllPropertiesCommand_20":
        case "DeleteAllPropertiesCommand_30":
        case "DeleteAllPropertiesCommand":
            {
                return new DeleteAllPropertiesCommand();
            };
        case "DeleteAllResponsesCommand_20":
        case "DeleteAllResponsesCommand_30":
        case "DeleteAllResponsesCommand":
            {
                return new DeleteAllResponsesCommand();
            };
        case "DeleteAllSecurityRequirementsCommand":
            {
                return new DeleteAllSecurityRequirementsCommand();
            };
        case "DeleteAllSecuritySchemesCommand":
            {
                return new DeleteAllSecuritySchemesCommand();
            };
        case "DeleteAllServersCommand":
            {
                return new DeleteAllServersCommand();
            };
        case "DeleteAllTagsCommand":
            {
                return new DeleteAllTagsCommand();
            };
        case "DeleteAllChildSchemasCommand":
            {
                return new DeleteAllChildSchemasCommand();
            };
        case "DeleteExampleCommand_20":
            {
                return new DeleteExampleCommand_20();
            };
        case "DeleteExampleCommand_30":
            {
                return new DeleteExampleCommand_30();
            };
        case "DeleteParameterExampleCommand_30":
            {
                return new DeleteParameterExampleCommand_30();
            };
        case "DeleteExtensionCommand":
            {
                return new DeleteExtensionCommand();
            };
        case "DeleteLicenseCommand":
        case "DeleteLicenseCommand_20":
        case "DeleteLicenseCommand_30":
            {
                return new DeleteLicenseCommand();
            };
        case "DeleteMediaTypeCommand":
            {
                return new DeleteMediaTypeCommand();
            };
        case "DeleteOperationCommand":
        case "DeleteOperationCommand_20":
        case "DeleteOperationCommand_30":
            {
                return new DeleteOperationCommand();
            };
        case "DeleteParameterCommand":
        case "DeleteParameterCommand_20":
        case "DeleteParameterCommand_30":
            {
                return new DeleteParameterCommand();
            };
        case "DeletePathCommand":
        case "DeletePathCommand_20":
        case "DeletePathCommand_30":
            {
                return new DeletePathCommand();
            };
        case "DeletePropertyCommand":
        case "DeletePropertyCommand_20":
        case "DeletePropertyCommand_30":
            {
                return new DeletePropertyCommand();
            };
        case "DeleteRequestBodyCommand":
        case "DeleteRequestBodyCommand_30":
            {
                return new DeleteRequestBodyCommand();
            };
        case "DeleteResponseCommand":
        case "DeleteResponseCommand_20":
        case "DeleteResponseCommand_30":
            {
                return new DeleteResponseCommand();
            };
        case "DeleteSchemaDefinitionCommand_20":
            {
                return new DeleteSchemaDefinitionCommand_20();
            };
        case "DeleteSchemaDefinitionCommand_30":
            {
                return new DeleteSchemaDefinitionCommand_30();
            };
        case "DeleteResponseDefinitionCommand_20":
            {
                return new DeleteResponseDefinitionCommand_20();
            };
        case "DeleteResponseDefinitionCommand_30":
            {
                return new DeleteResponseDefinitionCommand_30();
            };
        case "DeleteSecurityRequirementCommand":
            {
                return new DeleteSecurityRequirementCommand();
            };
        case "DeleteSecuritySchemeCommand_20":
            {
                return new DeleteSecuritySchemeCommand_20();
            };
        case "DeleteSecuritySchemeCommand_30":
            {
                return new DeleteSecuritySchemeCommand_30();
            };
        case "DeleteServerCommand":
            {
                return new DeleteServerCommand();
            };
        case "DeleteTagCommand":
        case "DeleteTagCommand_20":
        case "DeleteTagCommand_30":
            {
                return new DeleteTagCommand();
            };
        case "DeleteChildSchemaCommand":
            {
                return new DeleteChildSchemaCommand();
            };
        case "NewMediaTypeCommand":
            {
                return new NewMediaTypeCommand();
            };
        case "NewOperationCommand":
        case "NewOperationCommand_20":
        case "NewOperationCommand_30":
            {
                return new NewOperationCommand();
            };
        case "NewParamCommand":
        case "NewParamCommand_20":
        case "NewParamCommand_30":
            {
                return new NewParamCommand();
            };
        case "NewPathCommand":
        case "NewPathCommand_20":
        case "NewPathCommand_30":
            {
                return new NewPathCommand();
            };
        case "NewRequestBodyCommand_20":
            {
                return new NewRequestBodyCommand_20();
            };
        case "NewRequestBodyCommand_30":
            {
                return new NewRequestBodyCommand_30();
            };
        case "NewResponseCommand":
        case "NewResponseCommand_20":
        case "NewResponseCommand_30":
            {
                return new NewResponseCommand();
            };
        case "NewSchemaDefinitionCommand_20":
            {
                return new NewSchemaDefinitionCommand_20();
            };
        case "NewSchemaDefinitionCommand_30":
            {
                return new NewSchemaDefinitionCommand_30();
            };
        case "NewSchemaPropertyCommand":
        case "NewSchemaPropertyCommand_20":
        case "NewSchemaPropertyCommand_30":
            {
                return new NewSchemaPropertyCommand();
            };
        case "NewSecuritySchemeCommand_20":
            {
                return new NewSecuritySchemeCommand_20();
            };
        case "NewSecuritySchemeCommand_30":
            {
                return new NewSecuritySchemeCommand_30();
            };
        case "NewServerCommand":
            {
                return new NewServerCommand();
            };
        case "NewTagCommand":
        case "NewTagCommand_20":
        case "NewTagCommand_30":
            {
                return new NewTagCommand();
            };
        case "NewResponseDefinitionCommand_20":
            {
                return new NewResponseDefinitionCommand_20();
            };
        case "NewResponseDefinitionCommand_30":
            {
                return new NewResponseDefinitionCommand_30();
            };
        case "RenameParameterCommand":
            {
                return new RenameParameterCommand();
            };
        case "RenamePathItemCommand":
            {
                return new RenamePathItemCommand();
            };
        case "RenamePropertyCommand":
            {
                return new RenamePropertyCommand();
            };
        case "RenameSchemaDefinitionCommand_20":
            {
                return new RenameSchemaDefinitionCommand_20();
            };
        case "RenameSchemaDefinitionCommand_30":
            {
                return new RenameSchemaDefinitionCommand_30();
            };
        case "RenameSecuritySchemeCommand":
            {
                return new RenameSecuritySchemeCommand();
            };
        case "RenameTagDefinitionCommand":
            {
                return new RenameTagDefinitionCommand();
            };
        case "RenameResponseDefinitionCommand_20":
            {
                return new RenameResponseDefinitionCommand_20();
            };
        case "RenameResponseDefinitionCommand_30":
            {
                return new RenameResponseDefinitionCommand_30();
            };
        case "ReplaceOperationCommand_20":
        case "ReplaceOperationCommand_30":
        case "ReplaceOperationCommand":
            {
                return new ReplaceOperationCommand();
            };
        case "ReplaceDocumentCommand":
            {
                return new ReplaceDocumentCommand();
            };
        case "ReplacePathItemCommand_20":
        case "ReplacePathItemCommand_30":
        case "ReplacePathItemCommand":
            {
                return new ReplacePathItemCommand();
            };
        case "ReplaceSchemaDefinitionCommand_20":
            {
                return new ReplaceSchemaDefinitionCommand_20();
            };
        case "ReplaceSchemaDefinitionCommand_30":
            {
                return new ReplaceSchemaDefinitionCommand_30();
            };
        case "ReplaceSecurityRequirementCommand":
            {
                return new ReplaceSecurityRequirementCommand();
            };
        case "ReplaceResponseDefinitionCommand_20":
            {
                return new ReplaceResponseDefinitionCommand_20();
            };
        case "ReplaceResponseDefinitionCommand_30":
            {
                return new ReplaceResponseDefinitionCommand_30();
            };
        case "SetPropertyCommand":
            {
                return <any>(new SetPropertyCommand());
            };
        case "SetExampleCommand_20":
            {
                return new SetExampleCommand_20();
            };
        case "SetExampleCommand_30":
            {
                return new SetExampleCommand_30();
            };
        case "SetParameterExampleCommand_30":
            {
                return new SetParameterExampleCommand_30();
            };
        case "SetExtensionCommand":
            {
                return new SetExtensionCommand();
            };
        }
        return null;
    }

    public static createAggregateCommand(name : string, info : any, commands : Array<ICommand>) : ICommand {
        return new AggregateCommand(name, info, commands);
    }

    public static createAddExampleCommand(mediaType : Oas30MediaType, example : any, exampleName : string, exampleSummary : string, exampleDescription : string) : ICommand {
        return new AddExampleCommand_30(mediaType, example, exampleName, exampleSummary, exampleDescription);
    }

    public static createAddParameterExampleCommand(parameter : Oas30Parameter, example : any, exampleName : string, exampleSummary : string, exampleDescription : string) : ICommand {
        return new AddParameterExampleCommand_30(parameter, example, exampleName, exampleSummary, exampleDescription);
    }

    public static createAddSchemaDefinitionCommand(docType : DocumentType, definitionName : string, from : any) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new AddSchemaDefinitionCommand_20(definitionName, from);
        }
        if(docType === DocumentType.openapi3) {
            return new AddSchemaDefinitionCommand_30(definitionName, from);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createAddResponseDefinitionCommand(docType : DocumentType, definitionName : string, from : any) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new AddResponseDefinitionCommand_20(definitionName, from);
        }
        if(docType === DocumentType.openapi3) {
            return new AddResponseDefinitionCommand_30(definitionName, from);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createAddPathItemCommand(pathItemName : string, from : any) : ICommand {
        return new AddPathItemCommand(pathItemName, from);
    }

    public static createAddSecurityRequirementCommand(parent : ISecurityRequirementParent, requirement : SecurityRequirement) : ICommand {
        return new AddSecurityRequirementCommand(parent, requirement);
    }

    public static createAddChildSchemaCommand(schema : OasSchema, childSchema : OasSchema, childType : string) : ICommand {
        return new AddChildSchemaCommand(schema, childSchema, childType);
    }

    public static createChangePropertyCommand<T>(node : Node, property : string, newValue : T) : ICommand {
        return <any>(new ChangePropertyCommand<T>(node, property, newValue));
    }

    public static createChangeTitleCommand(newTitle : string) : ICommand {
        return new ChangeTitleCommand(newTitle);
    }

    public static createChangeDescriptionCommand(newDescription : string) : ICommand {
        return new ChangeDescriptionCommand(newDescription);
    }

    public static createChangeVersionCommand(newVersion : string) : ICommand {
        return new ChangeVersionCommand(newVersion);
    }

    public static createChangeLicenseCommand(name : string, url : string) : ICommand {
        return new ChangeLicenseCommand(name, url);
    }

    public static createChangeSchemaInheritanceCommand(schema : OasSchema, inheritanceType : string) : ICommand {
        return new ChangeSchemaInheritanceCommand(schema, inheritanceType);
    }

    public static createChangeContactCommand(name : string, email : string, url : string) : ICommand {
        return new ChangeContactCommand(name, email, url);
    }

    public static createChangeMediaTypeTypeCommand(mediaType : Oas30MediaType, newType : SimplifiedType) : ICommand {
        return new ChangeMediaTypeTypeCommand(mediaType, newType);
    }

    public static createChangeParameterTypeCommand(docType : DocumentType, parameter : Parameter, newType : SimplifiedParameterType) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new ChangeParameterTypeCommand_20(parameter, newType);
        }
        if(docType === DocumentType.openapi3) {
            return new ChangeParameterTypeCommand_30(parameter, newType);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createChangeParameterDefinitionTypeCommand(docType : DocumentType, parameter : Parameter, newType : SimplifiedParameterType) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new ChangeParameterDefinitionTypeCommand_20(parameter, newType);
        }
        if(docType === DocumentType.openapi3) {
            return new ChangeParameterDefinitionTypeCommand_30(parameter, newType);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createChangePropertyTypeCommand(property : IOasPropertySchema, newType : SimplifiedPropertyType) : ICommand {
        return new ChangePropertyTypeCommand(property, newType);
    }

    public static createChangeSchemaTypeCommand(schema : OasSchema, newType : SimplifiedType) : ICommand {
        return new ChangeSchemaTypeCommand(schema, newType);
    }

    public static createChangeResponseTypeCommand(response : Oas20Response, newType : SimplifiedType) : ICommand {
        return new ChangeResponseTypeCommand(response, newType);
    }

    public static createChangeResponseDefinitionTypeCommand(response : Oas20ResponseDefinition, newType : SimplifiedType) : ICommand {
        return new ChangeResponseTypeCommand(response, newType);
    }

    public static createChangeSecuritySchemeCommand(docType : DocumentType, scheme : SecurityScheme) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new ChangeSecuritySchemeCommand_20(scheme);
        } else if(docType === DocumentType.openapi3) {
            return new ChangeSecuritySchemeCommand_30(scheme);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createChangeServerCommand(server : Server) : ICommand {
        return new ChangeServerCommand(server);
    }

    public static createDeleteContactCommand(info : Info) : ICommand {
        return new DeleteContactCommand(info);
    }

    public static createDeleteChildSchemaCommand(schema : OasSchema) : ICommand {
        return new DeleteChildSchemaCommand(schema);
    }

    public static createDeleteAllExamplesCommand(mediaType : Oas30MediaType) : ICommand {
        return new DeleteAllExamplesCommand(mediaType);
    }

    public static createDeleteAllParameterExamplesCommand(parameter : Oas30Parameter) : ICommand {
        return new DeleteAllParameterExamplesCommand(parameter);
    }

    public static createDeleteAllOperationsCommand(pathItem : OasPathItem) : ICommand {
        return new DeleteAllOperationsCommand(pathItem);
    }

    public static createDeleteAllParametersCommand(parent : IOasParameterParent, type : string) : ICommand {
        return new DeleteAllParametersCommand(parent, type);
    }

    public static createDeleteAllPropertiesCommand(schema : OasSchema) : ICommand {
        return new DeleteAllPropertiesCommand(schema);
    }

    public static createDeleteAllResponsesCommand(operation : OasOperation) : ICommand {
        return new DeleteAllResponsesCommand(Constants.PROP_RESPONSES, operation);
    }

    public static createDeleteAllSecurityRequirementsCommand(parent : ISecurityRequirementParent) : ICommand {
        return new DeleteAllSecurityRequirementsCommand(parent);
    }

    public static createDeleteAllSecuritySchemesCommand() : ICommand {
        return new DeleteAllSecuritySchemesCommand();
    }

    public static createDeleteAllServersCommand(parent : IServerParent) : ICommand {
        return new DeleteAllServersCommand(parent);
    }

    public static createDeleteAllTagsCommand() : ICommand {
        return new DeleteAllTagsCommand();
    }

    public static createDeleteAllChildSchemasCommand(parent : OasSchema, type : string) : ICommand {
        return new DeleteAllChildSchemasCommand(parent, type);
    }

    public static createDelete20ExampleCommand(response : Oas20Response, contentType : string) : ICommand {
        return new DeleteExampleCommand_20(response, contentType);
    }

    public static createDeleteExampleCommand(example : Oas30Example) : ICommand {
        return new DeleteExampleCommand_30(example);
    }

    public static createDeleteParameterExampleCommand(example : Oas30Example) : ICommand {
        return new DeleteParameterExampleCommand_30(example);
    }

    public static createDeleteExtensionCommand(extension : Extension) : ICommand {
        return new DeleteExtensionCommand(extension);
    }

    public static createDeleteLicenseCommand(info : Info) : ICommand {
        return new DeleteLicenseCommand(info);
    }

    public static createDeleteMediaTypeCommand(mediaType : Oas30MediaType) : ICommand {
        return new DeleteMediaTypeCommand(mediaType);
    }

    public static createDeleteOperationCommand(opMethod : string, pathItem : OasPathItem) : ICommand {
        return new DeleteOperationCommand(opMethod, pathItem);
    }

    public static createDeleteParameterCommand(parameter : OasParameter) : ICommand {
        return new DeleteParameterCommand(parameter);
    }

    public static createDeletePathCommand(path : string) : ICommand {
        return new DeletePathCommand(path);
    }

    public static createDeletePropertyCommand(property : IOasPropertySchema) : ICommand {
        return new DeletePropertyCommand(property);
    }

    public static createDeleteRequestBodyCommand(operation : Oas30Operation) : ICommand {
        return new DeleteRequestBodyCommand(operation);
    }

    public static createDeleteResponseCommand(response : OasResponse) : ICommand {
        return new DeleteResponseCommand(response);
    }

    public static createDeleteSchemaDefinitionCommand(docType : DocumentType, definitionName : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new DeleteSchemaDefinitionCommand_20(definitionName);
        }
        if(docType === DocumentType.openapi3) {
            return new DeleteSchemaDefinitionCommand_30(definitionName);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createDeleteResponseDefinitionCommand(docType : DocumentType, definitionName : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new DeleteResponseDefinitionCommand_20(definitionName);
        }
        if(docType === DocumentType.openapi3) {
            return new DeleteResponseDefinitionCommand_30(definitionName);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createDeleteSecurityRequirementCommand(parent : ISecurityRequirementParent, requirement : SecurityRequirement) : ICommand {
        return new DeleteSecurityRequirementCommand(parent, requirement);
    }

    public static createDeleteSecuritySchemeCommand(docType : DocumentType, schemeName : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new DeleteSecuritySchemeCommand_20(schemeName);
        }
        if(docType === DocumentType.openapi3) {
            return new DeleteSecuritySchemeCommand_30(schemeName);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createDeleteServerCommand(server : Server) : ICommand {
        return new DeleteServerCommand(server);
    }

    public static createDeleteTagCommand(tagName : string) : ICommand {
        return new DeleteTagCommand(tagName);
    }

    /**
     * New Commands
     * @param {*} parent
     * @param {string} newMediaType
     * @return {*}
     */
    public static createNewMediaTypeCommand(parent : IOas30MediaTypeParent, newMediaType : string) : ICommand {
        return new NewMediaTypeCommand(parent, newMediaType);
    }

    public static createNewOperationCommand(path : string, method : string) : ICommand {
        return new NewOperationCommand(path, method);
    }

    public static createNewParamCommand(parent : IOasParameterParent, paramName : string, paramType : string, description : string, newType : SimplifiedParameterType, override : boolean) : ICommand {
        return new NewParamCommand(parent, paramName, paramType, description, newType, override);
    }

    public static createNewPathCommand(newPath : string) : ICommand {
        return new NewPathCommand(newPath);
    }

    public static createNewRequestBodyCommand(docType : DocumentType, operation : OasOperation) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new NewRequestBodyCommand_20(operation);
        }
        if(docType === DocumentType.openapi3) {
            return new NewRequestBodyCommand_30(operation);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createNewResponseCommand(operation : OasOperation, statusCode : string, sourceResponse : OasResponse) : ICommand {
        return new NewResponseCommand(operation, statusCode, sourceResponse);
    }

    public static createNewSchemaDefinitionCommand(docType : DocumentType, definitionName : string, example : any, description : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new NewSchemaDefinitionCommand_20(definitionName, example, description);
        }
        if(docType === DocumentType.openapi3) {
            return new NewSchemaDefinitionCommand_30(definitionName, example, description);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createNewResponseDefinitionCommand(docType : DocumentType, definitionName : string, description : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new NewResponseDefinitionCommand_20(definitionName, description);
        }
        if(docType === DocumentType.openapi3) {
            return new NewResponseDefinitionCommand_30(definitionName, description);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createNewSchemaPropertyCommand(schema : Schema, propertyName : string, description : string, newType : SimplifiedPropertyType) : ICommand {
        return new NewSchemaPropertyCommand(schema, propertyName, description, newType);
    }

    public static createNewSecuritySchemeCommand(docType : DocumentType, scheme : SecurityScheme) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new NewSecuritySchemeCommand_20(scheme);
        }
        if(docType === DocumentType.openapi3) {
            return new NewSecuritySchemeCommand_30(scheme);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createNewServerCommand(parent : IServerParent, server : Server) : ICommand {
        return new NewServerCommand(parent, server);
    }

    public static createNewTagCommand(name : string, description : string) : ICommand {
        return new NewTagCommand(name, description);
    }

    /**
     * Rename Commands
     * @param {*} parent
     * @param {string} oldParamName
     * @param {string} newParamName
     * @param {string} paramIn
     * @return {*}
     */
    public static createRenameParameterCommand(parent : IOasParameterParent, oldParamName : string, newParamName : string, paramIn : string) : ICommand {
        return new RenameParameterCommand(parent, oldParamName, newParamName, paramIn);
    }

    public static createRenamePathItemCommand(oldPath : string, newPath : string, alsoRenameSubpaths : boolean) : ICommand {
        return new RenamePathItemCommand(oldPath, newPath, alsoRenameSubpaths);
    }

    public static createRenamePropertyCommand(parent : OasSchema, oldPropertyName : string, newPropertyName : string) : ICommand {
        return new RenamePropertyCommand(parent, oldPropertyName, newPropertyName);
    }

    public static createRenameSchemaDefinitionCommand(docType : DocumentType, oldName : string, newName : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new RenameSchemaDefinitionCommand_20(oldName, newName);
        }
        if(docType === DocumentType.openapi3) {
            return new RenameSchemaDefinitionCommand_30(oldName, newName);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createRenameResponseDefinitionCommand(docType : DocumentType, oldName : string, newName : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new RenameResponseDefinitionCommand_20(oldName, newName);
        }
        if(docType === DocumentType.openapi3) {
            return new RenameResponseDefinitionCommand_30(oldName, newName);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createRenameSecuritySchemeCommand(oldSchemeName : string, newSchemeName : string) : ICommand {
        return new RenameSecuritySchemeCommand(oldSchemeName, newSchemeName);
    }

    public static createRenameTagDefinitionCommand(oldTag : string, newTag : string) : ICommand {
        return new RenameTagDefinitionCommand(oldTag, newTag);
    }

    public static createReplaceOperationCommand(old : OasOperation, replacement : OasOperation) : ICommand {
        return new ReplaceOperationCommand(old, replacement);
    }

    public static createReplaceDocumentCommand(old : Document, replacement : Document) : ICommand {
        return new ReplaceDocumentCommand(old, replacement);
    }

    public static createReplacePathItemCommand(old : OasPathItem, replacement : OasPathItem) : ICommand {
        return new ReplacePathItemCommand(old, replacement);
    }

    public static createReplaceSchemaDefinitionCommand(docType : DocumentType, old : IDefinition, replacement : IDefinition) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new ReplaceSchemaDefinitionCommand_20(<Oas20SchemaDefinition><any>old, <Oas20SchemaDefinition><any>replacement);
        }
        if(docType === DocumentType.openapi3) {
            return new ReplaceSchemaDefinitionCommand_30(<Oas30SchemaDefinition><any>old, <Oas30SchemaDefinition><any>replacement);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createReplaceResponseDefinitionCommand(docType : DocumentType, old : IDefinition, replacement : IDefinition) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new ReplaceResponseDefinitionCommand_20(<Oas20ResponseDefinition><any>old, <Oas20ResponseDefinition><any>replacement);
        }
        if(docType === DocumentType.openapi3) {
            return new ReplaceResponseDefinitionCommand_30(<Oas30ResponseDefinition><any>old, <Oas30ResponseDefinition><any>replacement);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createReplaceSecurityRequirementCommand(old : SecurityRequirement, replacement : SecurityRequirement) : ICommand {
        return new ReplaceSecurityRequirementCommand(old, replacement);
    }

    /**
     * Set Commands
     * @param {NodePath} path
     * @param {string} property
     * @param {*} newValue
     * @return {*}
     */
    public static createSetPropertyCommand<T>(path : NodePath, property : string, newValue : T) : ICommand {
        return <any>(new SetPropertyCommand<T>(path, property, newValue));
    }

    public static createSetExampleCommand(docType : DocumentType, parent : IExampleParent, example : any, nameOrContentType : string) : ICommand {
        if(docType === DocumentType.openapi2) {
            return new SetExampleCommand_20(<Oas20Response><any>parent, example, nameOrContentType);
        }
        if(docType === DocumentType.openapi3) {
            return new SetExampleCommand_30(<Oas30MediaType><any>parent, example, nameOrContentType);
        }
        throw Object.defineProperty(new Error("Document type not supported by this command."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }

    public static createSetParameterExampleCommand(parent : IExampleParent, example : any, exampleName : string) : ICommand {
        return new SetParameterExampleCommand_30(<Oas30Parameter><any>parent, example, exampleName);
    }

    public static createSetExtensionCommand(parent : ExtensibleNode, name : string, value : any) : ICommand {
        return new SetExtensionCommand(parent, name, value);
    }
}
CommandFactory["__class"] = "io.apicurio.datamodels.cmd.commands.CommandFactory";




import { SetExtensionCommand } from './SetExtensionCommand';


import { SetParameterExampleCommand_30 } from './SetParameterExampleCommand_30';


import { SetExampleCommand_30 } from './SetExampleCommand_30';


import { SetExampleCommand_20 } from './SetExampleCommand_20';


import { SetPropertyCommand } from './SetPropertyCommand';


import { ReplaceResponseDefinitionCommand_30 } from './ReplaceResponseDefinitionCommand_30';


import { ReplaceResponseDefinitionCommand_20 } from './ReplaceResponseDefinitionCommand_20';


import { ReplaceSecurityRequirementCommand } from './ReplaceSecurityRequirementCommand';


import { ReplaceSchemaDefinitionCommand_30 } from './ReplaceSchemaDefinitionCommand_30';


import { ReplaceSchemaDefinitionCommand_20 } from './ReplaceSchemaDefinitionCommand_20';


import { ReplacePathItemCommand } from './ReplacePathItemCommand';


import { ReplaceDocumentCommand } from './ReplaceDocumentCommand';


import { ReplaceOperationCommand } from './ReplaceOperationCommand';


import { RenameResponseDefinitionCommand_30 } from './RenameResponseDefinitionCommand_30';


import { RenameResponseDefinitionCommand_20 } from './RenameResponseDefinitionCommand_20';


import { RenameTagDefinitionCommand } from './RenameTagDefinitionCommand';


import { RenameSecuritySchemeCommand } from './RenameSecuritySchemeCommand';


import { RenameSchemaDefinitionCommand_30 } from './RenameSchemaDefinitionCommand_30';


import { RenameSchemaDefinitionCommand_20 } from './RenameSchemaDefinitionCommand_20';


import { RenamePropertyCommand } from './RenamePropertyCommand';


import { RenamePathItemCommand } from './RenamePathItemCommand';


import { RenameParameterCommand } from './RenameParameterCommand';


import { NewResponseDefinitionCommand_30 } from './NewResponseDefinitionCommand_30';


import { NewResponseDefinitionCommand_20 } from './NewResponseDefinitionCommand_20';


import { NewTagCommand } from './NewTagCommand';


import { NewServerCommand } from './NewServerCommand';


import { NewSecuritySchemeCommand_30 } from './NewSecuritySchemeCommand_30';


import { NewSecuritySchemeCommand_20 } from './NewSecuritySchemeCommand_20';


import { NewSchemaPropertyCommand } from './NewSchemaPropertyCommand';


import { NewSchemaDefinitionCommand_30 } from './NewSchemaDefinitionCommand_30';


import { NewSchemaDefinitionCommand_20 } from './NewSchemaDefinitionCommand_20';


import { NewResponseCommand } from './NewResponseCommand';


import { NewRequestBodyCommand_30 } from './NewRequestBodyCommand_30';


import { NewRequestBodyCommand_20 } from './NewRequestBodyCommand_20';


import { NewPathCommand } from './NewPathCommand';


import { NewParamCommand } from './NewParamCommand';


import { NewOperationCommand } from './NewOperationCommand';


import { NewMediaTypeCommand } from './NewMediaTypeCommand';


import { DeleteChildSchemaCommand } from './DeleteChildSchemaCommand';


import { DeleteTagCommand } from './DeleteTagCommand';


import { DeleteServerCommand } from './DeleteServerCommand';


import { DeleteSecuritySchemeCommand_30 } from './DeleteSecuritySchemeCommand_30';


import { DeleteSecuritySchemeCommand_20 } from './DeleteSecuritySchemeCommand_20';


import { DeleteSecurityRequirementCommand } from './DeleteSecurityRequirementCommand';


import { DeleteResponseDefinitionCommand_30 } from './DeleteResponseDefinitionCommand_30';


import { DeleteResponseDefinitionCommand_20 } from './DeleteResponseDefinitionCommand_20';


import { DeleteSchemaDefinitionCommand_30 } from './DeleteSchemaDefinitionCommand_30';


import { DeleteSchemaDefinitionCommand_20 } from './DeleteSchemaDefinitionCommand_20';


import { DeleteResponseCommand } from './DeleteResponseCommand';


import { DeleteRequestBodyCommand } from './DeleteRequestBodyCommand';


import { DeletePropertyCommand } from './DeletePropertyCommand';


import { DeletePathCommand } from './DeletePathCommand';


import { DeleteParameterCommand } from './DeleteParameterCommand';


import { DeleteOperationCommand } from './DeleteOperationCommand';


import { DeleteMediaTypeCommand } from './DeleteMediaTypeCommand';


import { DeleteLicenseCommand } from './DeleteLicenseCommand';


import { DeleteExtensionCommand } from './DeleteExtensionCommand';


import { DeleteParameterExampleCommand_30 } from './DeleteParameterExampleCommand_30';


import { DeleteExampleCommand_30 } from './DeleteExampleCommand_30';


import { DeleteExampleCommand_20 } from './DeleteExampleCommand_20';


import { DeleteAllChildSchemasCommand } from './DeleteAllChildSchemasCommand';


import { DeleteAllTagsCommand } from './DeleteAllTagsCommand';


import { DeleteAllServersCommand } from './DeleteAllServersCommand';


import { DeleteAllSecuritySchemesCommand } from './DeleteAllSecuritySchemesCommand';


import { DeleteAllSecurityRequirementsCommand } from './DeleteAllSecurityRequirementsCommand';


import { DeleteAllResponsesCommand } from './DeleteAllResponsesCommand';


import { DeleteAllPropertiesCommand } from './DeleteAllPropertiesCommand';


import { DeleteAllParametersCommand } from './DeleteAllParametersCommand';


import { DeleteAllOperationsCommand } from './DeleteAllOperationsCommand';


import { DeleteAllParameterExamplesCommand } from './DeleteAllParameterExamplesCommand';


import { DeleteAllExamplesCommand } from './DeleteAllExamplesCommand';


import { DeleteContactCommand } from './DeleteContactCommand';


import { ChangeSchemaInheritanceCommand } from './ChangeSchemaInheritanceCommand';


import { ChangeSchemaTypeCommand } from './ChangeSchemaTypeCommand';


import { ChangeServerCommand } from './ChangeServerCommand';


import { ChangeSecuritySchemeCommand_30 } from './ChangeSecuritySchemeCommand_30';


import { ChangeSecuritySchemeCommand_20 } from './ChangeSecuritySchemeCommand_20';


import { ChangeResponseTypeCommand } from './ChangeResponseTypeCommand';


import { ChangePropertyTypeCommand } from './ChangePropertyTypeCommand';


import { ChangeParameterDefinitionTypeCommand_30 } from './ChangeParameterDefinitionTypeCommand_30';


import { ChangeParameterTypeCommand_30 } from './ChangeParameterTypeCommand_30';


import { ChangeParameterDefinitionTypeCommand_20 } from './ChangeParameterDefinitionTypeCommand_20';


import { ChangeParameterTypeCommand_20 } from './ChangeParameterTypeCommand_20';


import { ChangeMediaTypeTypeCommand } from './ChangeMediaTypeTypeCommand';


import { ChangeLicenseCommand } from './ChangeLicenseCommand';


import { ChangeContactCommand } from './ChangeContactCommand';


import { ChangeVersionCommand } from './ChangeVersionCommand';


import { ChangeTitleCommand } from './ChangeTitleCommand';


import { ChangeDescriptionCommand } from './ChangeDescriptionCommand';


import { ChangePropertyCommand } from './ChangePropertyCommand';


import { AddChildSchemaCommand } from './AddChildSchemaCommand';


import { AddResponseDefinitionCommand_30 } from './AddResponseDefinitionCommand_30';


import { AddResponseDefinitionCommand_20 } from './AddResponseDefinitionCommand_20';


import { AddSecurityRequirementCommand } from './AddSecurityRequirementCommand';


import { AddPathItemCommand } from './AddPathItemCommand';


import { AddParameterExampleCommand_30 } from './AddParameterExampleCommand_30';


import { AddExampleCommand_30 } from './AddExampleCommand_30';


import { AddSchemaDefinitionCommand_30 } from './AddSchemaDefinitionCommand_30';


import { AddSchemaDefinitionCommand_20 } from './AddSchemaDefinitionCommand_20';


import { AggregateCommand } from './AggregateCommand';

